import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $popup = combine(i18n.$t, ({ t }) => ({
  descriptionTitle: `${t('description')}:`,
  directorsTitle: `${t('directors')}:`,
  starsTitle: `${t('stars')}:`,
  eventDateTitle: `${t('event_date')}:`,
  releaseYearTitle: `${t('release_year')}:`,
  durationTitle: `${t('duration')}:`,
  ageRatingTitle: `${t('age_rating')}:`,
}))
